import { render, staticRenderFns } from "./dialog.component.vue?vue&type=template&id=522639ec&"
import script from "./dialog.component.vue?vue&type=script&lang=js&"
export * from "./dialog.component.vue?vue&type=script&lang=js&"
import style0 from "./dialog.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports